export enum CTAButton {
  primary = 'primary',
  secondary = 'secondary',
}

export enum TagType {
  'primary' = 1,
  'secondary' = 2,
  'tertiary' = 3,
}
